<template lang="">
    <div>

   
        <v-container fluid >
            <v-layout align-center justify-center>
               <v-flex xs15 sm10 md10>
                  <v-card  height= 800px class="elevation-1">
                     
                    <home-page></home-page> 
                  </v-card>            
               </v-flex>
            </v-layout>
         </v-container>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import HomePage from "@/components/pages/HomePage.vue"
    
export default {
    components: { HomePage },

    data() {
        return {
         elementos_si_no:
            [
               {value:true,name:'Sí'},
               {value:false,name:'No'},
            ]
         ,
            datos_inicio:{
                'trabajador':'',
                'lote_mp':'',
                'lote_bolson':'',
                'cuerpos':'',
                'kg_membrana':'',
                'lote_membrana':'',
                'aviso_hmi': 0,
            }
        }
    },

    computed: {
        ...mapState(['client'])
    },

    methods: {
        ...mapActions(['doPublish']),
        iniciar(){
            this.datos_inicio.aviso_hmi = 1
            //Publicará los datos de inicio de ciclo
            let publication={
              topic:'ciclo',
              qos:2,
              payload:JSON.stringify({'datos':this.datos_inicio}) ,
            }
            this.doPublish(publication)
        },
    },
    
    
}
</script>
<style lang="">
    
</style>